/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  BranchesApiConfig,
  MapConfig,
  PartnerAssetsConfig,
} from "@farmlands/card-partners-directory";

export const mapConfig: MapConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!,
  zoom: 6,
};

export const branchesApi: BranchesApiConfig = {
  baseUrl: process.env.REACT_APP_CARD_PARTNERS_DIRECTORY_API_URL!,
  pageSize: 10000,
};

export const partnerAssets: PartnerAssetsConfig = {
  baseUrl: process.env.REACT_APP_CARD_PARTNERS_DIRECTORY_ASSETS_URL!,
};

export const MOBILE_LIST_STICKY_TOP_OFFSET = "1rem";

export const categoriesApiConfig = {
  baseUrl: process.env.REACT_APP_CARD_PARTNERS_DIRECTORY_API_URL!,
};

export const cardPartnersDirectoryWebUrl = process.env.REACT_APP_CARD_PARTNERS_DIRECTORY_WEB_URL!;
